import { render, staticRenderFns } from "./video-events-card.vue?vue&type=template&id=6441842a&scoped=true&"
import script from "./video-events-card.vue?vue&type=script&lang=js&"
export * from "./video-events-card.vue?vue&type=script&lang=js&"
import style0 from "./video-events-card.vue?vue&type=style&index=0&id=6441842a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6441842a",
  null
  
)

export default component.exports